/* =================================================================
   chillpod-buy-section.js
   =================================================================
   PART 1 — Shape selector + scroll position save/restore
   PART 2 — Chiller toggle (עם מצנן / בלי מצנן)
   PART 3 — Chiller package selector (חבילת מצנן / צ'ילפוד + מצנן)
            + chiller add-ons (מצנן בלבד: משטח הגנה + מסננים)
   PART 4 — No-chiller package selector (פרו / בסיסי)
            + add-ons (בלוקים + משטח הגנה) — visible only on בסיסי
   PART 5 — Totals + Add to cart
   ================================================================= */


/* ============================ PART 1 ============================
   Shape selector
   ================================================================ */
(function () {
  function initShapeSelector() {
    const selector = document.getElementById("hlShapeSelector");
    if (!selector) return;

    const current = selector.dataset.current || "chillpod";
    const options = selector.querySelectorAll(".hl-shape-option");
    const nameEl  = document.getElementById("hlShapeSelectedName");

    options.forEach((opt) => {
      const isActive = opt.dataset.product === current;
      opt.classList.toggle("is-active", isActive);
      opt.setAttribute("aria-current", isActive ? "true" : "false");

      if (isActive && nameEl) nameEl.textContent = opt.dataset.name || "";

      const priceEl = opt.querySelector("[data-shape-price]");
      if (priceEl && opt.dataset.price) {
        const cents = Number(opt.dataset.price);
        if (!Number.isNaN(cents) && cents > 0) {
          priceEl.textContent = "₪" + Math.round(cents / 100).toLocaleString("en-US");
        }
      }

      if (opt.dataset.bound === "1") return;
      opt.dataset.bound = "1";

      opt.addEventListener("click", (e) => {
        if (opt.dataset.product === current) { e.preventDefault(); return; }
        e.preventDefault();
        window.location.href = opt.getAttribute("href");
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initShapeSelector);
  } else {
    initShapeSelector();
  }
})();


/* ======================= PARTS 2–5 =================================
   Chiller toggle + package selectors + add-ons + totals
   ================================================================ */
window.hlInitIceAddon = function () {

  // ── Config ────────────────────────────────────────────────────
  const ICE_BUNDLES = [
    { label: "6",  handle: "ib-6",  id: "48064623083779", qty: 6,  imageUrl: "https://cdn.shopify.com/s/files/1/0609/2141/3891/files/6_Pack_46d031be-449d-4db8-b860-7afeabbeb4cf.png?v=1778783621" },
    { label: "9",  handle: "ib-9",  id: "48138351051011", qty: 9,  imageUrl: "https://cdn.shopify.com/s/files/1/0609/2141/3891/files/9_Pack_c5b86d04-4319-421f-b203-c4357581252e.png?v=1778783621" },
    { label: "12", handle: "ib-12", id: "48064636158211", qty: 12, imageUrl: "https://cdn.shopify.com/s/files/1/0609/2141/3891/files/12_Pack_a2da260d-1c7c-4a06-9dca-31dc128631bd.png?v=1778783621" },
  ];

  const ICE_BADGES = {
    "48138351051011": "פופולרי",
    "48064636158211": "הכי משתלם",
  };

  const MAT_IDS = {
    "chillpod":      { variantId: "47840588497155", jsonId: "hl-mat-chillpod-json" },
    "chillpod-plus": { variantId: "47840589480195", jsonId: "hl-mat-chillpod-plus-json" },
  };

  const PRO_BUNDLE_IDS = {
    "chillpod":      { variantId: "48330782376195", jsonId: "hl-pro-bundle-json" },
    "chillpod-plus": { variantId: "48330771693827", jsonId: "hl-pro-bundle-plus-json" },
  };

  const CHILLER_BUNDLE_IDS = {
    "chillpod":      { variantId: "49256642412803", jsonId: "hl-chiller-bundle-chillpod-json" },
    "chillpod-plus": { variantId: "49256642806019", jsonId: "hl-chiller-bundle-plus-json" },
  };

  // Universal (same across both shapes)
  const CHILLER_STANDALONE = { variantId: "47766086353155", jsonId: "hl-chiller-json" };
  const FILTERS_ADDON      = { variantId: "47835174928643", jsonId: "hl-filters-json" };

  // ── Shape context ────────────────────────────────────────────
  const currentProduct = document.getElementById("hlShapeSelector")?.dataset?.current || "chillpod";

  const mainEl = document.getElementById("hl-main-product-json");
  if (!mainEl) return;

  let chillpod;
  try { chillpod = JSON.parse(mainEl.textContent); } catch { return; }

  const chillpodVariant      = chillpod?.variants?.[0];
  const chillpodVariantId    = chillpodVariant ? Number(chillpodVariant.id) : null;
  const chillpodPriceCents   = chillpodVariant ? Number(chillpodVariant.price) : 0;
  const chillpodCompareCents = chillpodVariant?.compare_at_price ? Number(chillpodVariant.compare_at_price) : 0;

  if (!chillpodVariantId) return;

  // ── Generic helper: read a variant's price/image data from an embedded product JSON block ──
  function readVariant(jsonId, variantId) {
    const el = document.getElementById(jsonId);
    if (!el) return null;
    try {
      const product = JSON.parse(el.textContent);
      const variant = (product?.variants || []).find((v) => String(v.id) === String(variantId)) || product?.variants?.[0];
      if (!variant) return null;
      let imageUrl = null;
      if (variant.image_id) {
        const img = (product?.images || []).find((i) => i.id === variant.image_id);
        if (img) imageUrl = img.src;
      }
      if (!imageUrl) imageUrl = product?.featured_image || product?.images?.[0]?.src || null;
      return {
        variantId: Number(variant.id),
        price: Number(variant.price) || 0,
        compare_at_price: variant.compare_at_price ? Number(variant.compare_at_price) : 0,
        imageUrl,
      };
    } catch { return null; }
  }

  // ── Parse ice bundle data ─────────────────────────────────────
  const bundleDataMap = new Map();
  for (const bundle of ICE_BUNDLES) {
    const data = readVariant(`hl-ice-bundle-product-json-${bundle.handle}`, bundle.id);
    if (data) bundleDataMap.set(String(bundle.id), data);
  }
  bundleDataMap.forEach((d) => { if (d.imageUrl) { const i = new Image(); i.src = d.imageUrl; } });

  // ── Parse mat data (shared between chiller-alone card and no-chiller/basic card) ──
  const matConfig = MAT_IDS[currentProduct];
  const matData = matConfig ? readVariant(matConfig.jsonId, matConfig.variantId) : null;
  const matVariantId    = matData ? matData.variantId : null;
  const matPriceCents   = matData ? matData.price : 0;
  const matCompareCents = matData ? matData.compare_at_price : 0;

  // ── Parse pro bundle data (no-chiller bundle) ──────────────────
  const proConfig = PRO_BUNDLE_IDS[currentProduct];
  const proData = proConfig ? readVariant(proConfig.jsonId, proConfig.variantId) : null;
  const proVariantId    = proData ? proData.variantId : null;
  const proPriceCents   = proData ? proData.price : 0;
  const proCompareCents = proData ? proData.compare_at_price : 0;

  // ── Parse chiller bundle data (single SKU: ice bath + chiller + mat + filters) ──
  const chillerBundleConfig = CHILLER_BUNDLE_IDS[currentProduct];
  const chillerBundleData = chillerBundleConfig ? readVariant(chillerBundleConfig.jsonId, chillerBundleConfig.variantId) : null;
  const chillerBundleVariantId    = chillerBundleData ? chillerBundleData.variantId : null;
  const chillerBundlePriceCents   = chillerBundleData ? chillerBundleData.price : 0;
  const chillerBundleCompareCents = chillerBundleData ? chillerBundleData.compare_at_price : 0;

  // ── Parse standalone chiller data (universal, added as its own line item) ──
  const chillerData = readVariant(CHILLER_STANDALONE.jsonId, CHILLER_STANDALONE.variantId);
  const chillerVariantId    = chillerData ? chillerData.variantId : null;
  const chillerPriceCents   = chillerData ? chillerData.price : 0;
  const chillerCompareCents = chillerData ? chillerData.compare_at_price : 0;

  // ── Parse filters data (universal) ──────────────────────────────
  const filtersData = readVariant(FILTERS_ADDON.jsonId, FILTERS_ADDON.variantId);
  const filtersVariantId    = filtersData ? filtersData.variantId : null;
  const filtersPriceCents   = filtersData ? filtersData.price : 0;
  const filtersCompareCents = filtersData ? filtersData.compare_at_price : 0;

  // ── Element refs: chiller toggle ────────────────────────────────
  const chillerToggle     = document.getElementById("hlChillerToggle");
  const chillerToggleBtns = chillerToggle ? chillerToggle.querySelectorAll(".hl-chiller-toggle-option") : [];

  // ── Element refs: chiller package selector ──────────────────────
  const chillerPkgSelector = document.getElementById("hlChillerPkgSelector");
  const chillerPkgBtns     = chillerPkgSelector ? chillerPkgSelector.querySelectorAll(".hl-pkg-option") : [];
  const chillerAddonsRoot  = document.getElementById("hlChillerAddonsRoot");

  const chillerBundlePriceEl    = document.getElementById("hlChillerBundlePrice");
  const chillerBundleInstallmentsEl = document.getElementById("hlChillerBundleInstallments");
  const chillerBundleCompareEl  = document.getElementById("hlChillerBundleCompare");
  const chillerBundleDiscountEl = document.getElementById("hlChillerBundleDiscount");
  const chillerAlonePriceEl     = document.getElementById("hlChillerAlonePrice");
  const chillerAloneInstallmentsEl = document.getElementById("hlChillerAloneInstallments");
  const chillerAloneCompareEl   = document.getElementById("hlChillerAloneCompare");
  const chillerAloneDiscountEl  = document.getElementById("hlChillerAloneDiscount");

  const chillerMatCheck     = document.getElementById("hlChillerMatCheck");
  const chillerMatCard      = document.getElementById("hlChillerMatCard");
  const chillerMatPriceEl   = document.getElementById("hlChillerMatPrice");
  const chillerMatCompareEl = document.getElementById("hlChillerMatCompareAt");

  const filtersCheck     = document.getElementById("hlFiltersCheck");
  const filtersCard      = document.getElementById("hlFiltersCard");
  const filtersPriceEl   = document.getElementById("hlFiltersPrice");
  const filtersCompareEl = document.getElementById("hlFiltersCompareAt");

  // ── Element refs: no-chiller package selector (existing) ────────
  const pkgSelector   = document.getElementById("hlPackageSelector");
  const pkgBasicDesc  = document.getElementById("hlPkgBasicDesc");
  const pkgProDesc    = document.getElementById("hlPkgProDesc");
  const pkgBasicPrice = document.getElementById("hlPkgBasicPrice");
  const pkgProPrice   = document.getElementById("hlPkgProPrice");
  const pkgButtons    = pkgSelector ? pkgSelector.querySelectorAll(".hl-pkg-option") : [];

  const addonsRoot    = document.getElementById("hlAddonsRoot");

  const iceCheck       = document.getElementById("hlIceCheck");
  const iceCard        = document.getElementById("hlIceCard");
  const pillsContainer = document.getElementById("hlIcePills");
  const icePriceEl     = document.getElementById("hlIcePrice");
  const iceCompareEl   = document.getElementById("hlIceCompareAt");
  const perUnitEl      = document.getElementById("hlIcePerUnit");
  const iceImgEl       = document.querySelector("#hlIceAddonRoot .hl-ice-image img");
  const badgeEl        = document.getElementById("hlIceBadge");

  const matCheck     = document.getElementById("hlMatCheck");
  const matCard      = document.getElementById("hlMatCard");
  const matPriceEl   = document.getElementById("hlMatPrice");
  const matCompareEl = document.getElementById("hlMatCompareAt");

  const totalEl         = document.getElementById("hlTotalPrice");
  const compareEl       = document.getElementById("hlTotalCompareAt");
  const discountBadgeEl = document.getElementById("hlTotalDiscountBadge");
  const installmentsEl  = document.getElementById("hlInstallments");
  const addBtn          = document.getElementById("hlAddBothToCart");

  // ── State ─────────────────────────────────────────────────────
  let chillerEnabled    = false;     // Cooling method? default: ice (no chiller)
  let chillerPkg        = "bundle";  // "bundle" | "alone" — default Chiller Bundle
  let noChillerPkg       = "pro";     // "pro" | "basic" — default Bundle
  let iceEnabled          = false;
  let matEnabled          = false;   // no-chiller / no-bundle mat
  let chillerMatEnabled   = false;   // chiller / alone mat
  let filtersEnabled      = false;
  let selectedIceId       = String(ICE_BUNDLES[0].id);

  // ── Helpers ───────────────────────────────────────────────────
  const money  = (cents)   => "₪" + Math.round(cents / 100).toLocaleString("en-US");
  const money2 = (shekels) => "₪" + Number(shekels).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  // ── No-chiller package descriptions & prices ────────────────────
  if (pkgBasicDesc) pkgBasicDesc.textContent = currentProduct === 'chillpod-plus' ? 'גדול במיוחד, מבודד קור, מסגרת מתכת יציבה, מתאים לגובה של עד 2.05 מטר.' : 'גדול ומרווח, מבודד קור, מתאים לגובה של עד 2 מטר.';
  if (pkgProDesc)   pkgProDesc.textContent   = currentProduct === 'chillpod-plus' ? 'צ׳ילפוד פלוס, משטח הגנה, ו-12 אייס בלוק להקפאה חוזרת.'  : 'צ׳ילפוד, משטח הגנה, ו-12 אייס בלוק להקפאה חוזרת.';

  if (pkgBasicPrice) pkgBasicPrice.textContent = money(chillpodPriceCents);

  const pkgBasicCompare  = document.getElementById("hlPkgBasicCompare");
  const pkgBasicDiscount = document.getElementById("hlPkgBasicDiscount");
  if (pkgBasicCompare && chillpodCompareCents > chillpodPriceCents) {
    pkgBasicCompare.textContent = money(chillpodCompareCents);
    pkgBasicCompare.style.display = "inline";
    if (pkgBasicDiscount) {
      pkgBasicDiscount.textContent = `${money(chillpodCompareCents - chillpodPriceCents)} הנחה`;
      pkgBasicDiscount.style.display = "inline";
    }
  }

  if (pkgProPrice && proPriceCents) {
    pkgProPrice.textContent = money(proPriceCents);
    const proComparePrice = proCompareCents > proPriceCents ? proCompareCents : 0;
    if (proComparePrice) {
      const pkgProCompare  = document.getElementById("hlPkgProCompare");
      const pkgProDiscount = document.getElementById("hlPkgProDiscount");
      if (pkgProCompare) { pkgProCompare.textContent = money(proComparePrice); pkgProCompare.style.display = "inline"; }
      if (pkgProDiscount) {
        pkgProDiscount.textContent = `${money(proComparePrice - proPriceCents)} הנחה`;
        pkgProDiscount.style.display = "inline";
      }
    }
  }

  // ── Chiller Bundle price ────────────────────────────────────────
  if (chillerBundlePriceEl && chillerBundlePriceCents) {
    chillerBundlePriceEl.textContent = money(chillerBundlePriceCents);
    if (chillerBundleInstallmentsEl) {
      chillerBundleInstallmentsEl.innerHTML = `<strong>${money2((chillerBundlePriceCents / 100) / 12)}</strong> ב-12 תשלומים ללא ריבית`;
    }
    if (chillerBundleCompareEl && chillerBundleCompareCents > chillerBundlePriceCents) {
      chillerBundleCompareEl.textContent = money(chillerBundleCompareCents);
      chillerBundleCompareEl.style.display = "inline";
      if (chillerBundleDiscountEl) {
        chillerBundleDiscountEl.textContent = `${money(chillerBundleCompareCents - chillerBundlePriceCents)} הנחה`;
        chillerBundleDiscountEl.style.display = "inline";
      }
    }
  }

  // ── Chiller "alone" price (base ice bath + standalone chiller, summed) ──
  const chillerAlonePriceCents   = chillpodPriceCents + chillerPriceCents;
  const chillerAloneCompareCents = chillpodCompareCents + chillerCompareCents;
  if (chillerAlonePriceEl) {
    chillerAlonePriceEl.textContent = money(chillerAlonePriceCents);
    if (chillerAloneInstallmentsEl) {
      chillerAloneInstallmentsEl.innerHTML = `<strong>${money2((chillerAlonePriceCents / 100) / 12)}</strong> ב-12 תשלומים ללא ריבית`;
    }
    if (chillerAloneCompareCents > chillerAlonePriceCents) {
      if (chillerAloneCompareEl) {
        chillerAloneCompareEl.textContent = money(chillerAloneCompareCents);
        chillerAloneCompareEl.style.display = "inline";
      }
      if (chillerAloneDiscountEl) {
        chillerAloneDiscountEl.textContent = `${money(chillerAloneCompareCents - chillerAlonePriceCents)} הנחה`;
        chillerAloneDiscountEl.style.display = "inline";
      }
    }
  }

  // ── Ice pills init ────────────────────────────────────────────
  if (pillsContainer) {
    pillsContainer.innerHTML = ICE_BUNDLES.map((b) => `
      <button
        type="button"
        class="hl-ice-pill${String(b.id) === selectedIceId ? " is-active" : ""}"
        data-id="${b.id}"
        aria-pressed="${String(b.id) === selectedIceId}"
      >${b.label}</button>
    `).join("");

    pillsContainer.addEventListener("click", (e) => {
      e.stopPropagation();
      const pill = e.target.closest(".hl-ice-pill");
      if (!pill) return;
      selectedIceId = pill.dataset.id;
      pillsContainer.querySelectorAll(".hl-ice-pill").forEach((p) => {
        const active = p.dataset.id === selectedIceId;
        p.classList.toggle("is-active", active);
        p.setAttribute("aria-pressed", active ? "true" : "false");
      });
      updateTotals();
      updateIceCard();
    });
  }

  // ── Mat init (no-chiller / no-bundle card) ──────────────────────
  if (matPriceEl) matPriceEl.textContent = matPriceCents ? money(matPriceCents) : "—";
  if (matCompareEl && matCompareCents > matPriceCents) {
    matCompareEl.textContent = money(matCompareCents);
    matCompareEl.style.display = "inline";
  }

  // ── Mat init (chiller / alone card — same product/price, separate DOM) ──
  if (chillerMatPriceEl) chillerMatPriceEl.textContent = matPriceCents ? money(matPriceCents) : "—";
  if (chillerMatCompareEl && matCompareCents > matPriceCents) {
    chillerMatCompareEl.textContent = money(matCompareCents);
    chillerMatCompareEl.style.display = "inline";
  }

  // ── Filters init ─────────────────────────────────────────────
  if (filtersPriceEl) filtersPriceEl.textContent = filtersPriceCents ? money(filtersPriceCents) : "—";
  if (filtersCompareEl && filtersCompareCents > filtersPriceCents) {
    filtersCompareEl.textContent = money(filtersCompareCents);
    filtersCompareEl.style.display = "inline";
  }

  // ── Update ice card display ───────────────────────────────────
  function updateIceCard() {
    const bundleMeta = ICE_BUNDLES.find((b) => String(b.id) === selectedIceId);
    const bundleData = bundleDataMap.get(selectedIceId);
    if (!bundleMeta || !bundleData) return;

    if (iceImgEl) iceImgEl.src = bundleMeta.imageUrl || bundleData.imageUrl;

    if (badgeEl) {
      const label = ICE_BADGES[selectedIceId];
      badgeEl.textContent = label || "";
      badgeEl.style.display = label ? "block" : "none";
    }

    const iceCents        = bundleData.price;
    const iceCompareCents = bundleData.compare_at_price;
    const qty             = bundleMeta.qty || 1;

    if (icePriceEl) icePriceEl.textContent = money(iceCents);

    if (iceCompareEl) {
      if (iceCompareCents > iceCents) {
        iceCompareEl.textContent = money(iceCompareCents);
        iceCompareEl.style.display = "inline";
      } else {
        iceCompareEl.style.display = "none";
        iceCompareEl.textContent = "";
      }
    }

    if (perUnitEl) perUnitEl.textContent = `${money2((iceCents / 100) / qty)} ליחידה`;
  }

  // ── Update totals ─────────────────────────────────────────────
  function updateTotals() {
    let total   = 0;
    let compare = 0;

    if (chillerEnabled) {
      if (chillerPkg === "bundle") {
        total   = chillerBundlePriceCents;
        compare = chillerBundleCompareCents;
      } else {
        // "alone" = base ice bath + standalone chiller, two separate line items
        total   = chillpodPriceCents + chillerPriceCents;
        compare = chillpodCompareCents + chillerCompareCents;

        if (chillerMatEnabled) {
          total   += matPriceCents;
          compare += (matCompareCents || matPriceCents);
        }
        if (filtersEnabled) {
          total   += filtersPriceCents;
          compare += (filtersCompareCents || filtersPriceCents);
        }
      }
    } else {
      if (noChillerPkg === "pro") {
        total   = proPriceCents;
        compare = proCompareCents;
      } else {
        total   = chillpodPriceCents;
        compare = chillpodCompareCents;

        if (iceEnabled) {
          const bd = bundleDataMap.get(selectedIceId);
          if (bd) {
            total   += bd.price;
            compare += (bd.compare_at_price || bd.price);
          }
        }

        if (matEnabled) {
          total   += matPriceCents;
          compare += (matCompareCents || matPriceCents);
        }
      }
    }

    if (totalEl) totalEl.textContent = money(total);

    if (compareEl) {
      if (compare > total) {
        compareEl.textContent = money(compare);
        compareEl.style.display = "block";
      } else {
        compareEl.style.display = "none";
        compareEl.textContent = "";
      }
    }

    if (discountBadgeEl) {
      if (compare > total) {
        const pct = Math.round((1 - (total / compare)) * 100);
        discountBadgeEl.textContent = `${pct}% הנחה`;
        discountBadgeEl.style.display = "inline-block";
      } else {
        discountBadgeEl.style.display = "none";
        discountBadgeEl.textContent = "";
      }
    }

    if (installmentsEl) {
      const installmentCount = chillerEnabled ? 12 : (currentProduct === "chillpod-plus" ? 6 : 3);
      const perPayment = (total / 100) / installmentCount;
      installmentsEl.innerHTML = `או <strong>₪${perPayment.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong> ב-${installmentCount} תשלומים ללא ריבית`;
    }

    if (addBtn) {
      addBtn.textContent = chillerEnabled ? "הזמנה מוקדמת – נשלח ב-26/07" : "הוספה לסל";
    }
  }

  // ── Reusable add-ons show/hide animation controller ─────────────
  function makeAddonsController(rootEl, onHideReset) {
    let visible = false;
    let resizeObserver = null;
    return function setVisible(next, instant) {
      if (!rootEl) return;
      if (next === visible) return; // already in the requested state — nothing to do
      visible = next;

      if (next) {
        if (instant) {
          const prevTransition = rootEl.style.transition;
          rootEl.style.transition = "none";
          rootEl.style.maxHeight     = rootEl.scrollHeight + "px";
          rootEl.style.opacity       = "1";
          rootEl.style.pointerEvents = "auto";
          void rootEl.offsetHeight; // force reflow so "none" actually applies before restoring
          rootEl.style.transition = prevTransition || "";
        } else {
          rootEl.style.maxHeight     = rootEl.scrollHeight + "px";
          rootEl.style.opacity       = "1";
          rootEl.style.pointerEvents = "auto";
        }

        if (!resizeObserver && "ResizeObserver" in window) {
          resizeObserver = new ResizeObserver(() => {
            if (visible) rootEl.style.maxHeight = rootEl.scrollHeight + "px";
          });
          resizeObserver.observe(rootEl);
        }
      } else {
        if (instant) {
          const prevTransition = rootEl.style.transition;
          rootEl.style.transition = "none";
          rootEl.style.maxHeight     = "0px";
          rootEl.style.opacity       = "0";
          rootEl.style.pointerEvents = "none";
          void rootEl.offsetHeight;
          rootEl.style.transition = prevTransition || "";
        } else {
          rootEl.style.maxHeight = rootEl.scrollHeight + "px";
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              if (visible) return; // user re-opened before this ran — bail
              rootEl.style.maxHeight     = "0px";
              rootEl.style.opacity       = "0";
              rootEl.style.pointerEvents = "none";
            });
          });
        }
        if (onHideReset) onHideReset();
      }
    };
  }

  const setAddonsVisible = makeAddonsController(addonsRoot, () => {
    if (iceEnabled) { iceEnabled = false; syncIceUI(); }
    if (matEnabled) { matEnabled = false; syncMatUI(); }
  });

  const setChillerAddonsVisible = makeAddonsController(chillerAddonsRoot, () => {
    if (chillerMatEnabled) { chillerMatEnabled = false; syncChillerMatUI(); }
    if (filtersEnabled)    { filtersEnabled = false; syncFiltersUI(); }
  });

  // Package selectors overlap in the same grid cell (see CSS) and are the
  // same height, so swapping between them is a pure opacity crossfade —
  // no max-height math, no reflow, no jump.
  function setPkgSelectorVisible(el, visible) {
    if (!el) return;
    el.style.opacity = visible ? "1" : "0";
    el.style.pointerEvents = visible ? "auto" : "none";
  }
  const setChillerPkgVisible   = (v) => setPkgSelectorVisible(chillerPkgSelector, v);
  const setNoChillerPkgVisible = (v) => setPkgSelectorVisible(pkgSelector, v);

  // ── Sync checkbox UIs ─────────────────────────────────────────
  function syncIceUI() {
    if (iceCheck) iceCheck.setAttribute("aria-pressed", iceEnabled ? "true" : "false");
    if (iceCard)  iceCard.classList.toggle("is-selected", iceEnabled);
  }

  function syncMatUI() {
    if (matCheck) matCheck.setAttribute("aria-pressed", matEnabled ? "true" : "false");
    if (matCard)  matCard.classList.toggle("is-selected", matEnabled);
  }

  function syncChillerMatUI() {
    if (chillerMatCheck) chillerMatCheck.setAttribute("aria-pressed", chillerMatEnabled ? "true" : "false");
    if (chillerMatCard)  chillerMatCard.classList.toggle("is-selected", chillerMatEnabled);
  }

  function syncFiltersUI() {
    if (filtersCheck) filtersCheck.setAttribute("aria-pressed", filtersEnabled ? "true" : "false");
    if (filtersCard)  filtersCard.classList.toggle("is-selected", filtersEnabled);
  }

  // ── Chiller toggle interaction ──────────────────────────────────
  function syncChillerToggleUI() {
    chillerToggleBtns.forEach((b) => {
      const active = (b.dataset.chiller === "yes") === chillerEnabled;
      b.classList.toggle("is-active", active);
      b.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  chillerToggleBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const nextEnabled = btn.dataset.chiller === "yes";
      if (nextEnabled === chillerEnabled) return;
      chillerEnabled = nextEnabled;
      syncChillerToggleUI();

      if (chillerEnabled) {
        setNoChillerPkgVisible(false);
        setAddonsVisible(false, true);
        setChillerPkgVisible(true);
        setChillerAddonsVisible(chillerPkg === "alone", true);
      } else {
        setChillerPkgVisible(false);
        setChillerAddonsVisible(false, true);
        setNoChillerPkgVisible(true);
        setAddonsVisible(noChillerPkg === "basic", true);
      }
      updateTotals();
    });
  });

  // ── Chiller package selector interaction ────────────────────────
  chillerPkgBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      if (e.target.closest("[data-modal]")) return;
      chillerPkg = btn.dataset.chillerPkg;
      chillerPkgBtns.forEach((b) => {
        const active = b.dataset.chillerPkg === chillerPkg;
        b.classList.toggle("is-active", active);
        b.setAttribute("aria-pressed", active ? "true" : "false");
      });
      setChillerAddonsVisible(chillerPkg === "alone");
      updateTotals();
    });
  });

  // ── No-chiller package selector interaction (existing) ──────────
  pkgButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      noChillerPkg = btn.dataset.pkg;
      pkgButtons.forEach((b) => {
        const active = b.dataset.pkg === noChillerPkg;
        b.classList.toggle("is-active", active);
        b.setAttribute("aria-pressed", active ? "true" : "false");
      });
      setAddonsVisible(noChillerPkg === "basic");
      updateTotals();
    });
  });

  // ── Ice card interaction (no-chiller / no-bundle) ─────────────────
  if (iceCheck) {
    iceCheck.addEventListener("click", (e) => {
      e.stopPropagation();
      iceEnabled = !iceEnabled;
      syncIceUI();
      updateTotals();
    });
  }

  if (iceCard) {
    iceCard.addEventListener("click", (e) => {
      if (e.target.closest(".hl-ice-details-btn, .hl-ice-pill, .hl-ice-pills")) return;
      iceEnabled = !iceEnabled;
      syncIceUI();
      updateTotals();
    });

    iceCard.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        iceEnabled = !iceEnabled;
        syncIceUI();
        updateTotals();
      }
    });
  }

  // ── Mat card interaction (no-chiller / no-bundle) ──────────────────
  if (matCheck) {
    matCheck.addEventListener("click", (e) => {
      e.stopPropagation();
      matEnabled = !matEnabled;
      syncMatUI();
      updateTotals();
    });
  }

  if (matCard) {
    matCard.addEventListener("click", () => {
      matEnabled = !matEnabled;
      syncMatUI();
      updateTotals();
    });

    matCard.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        matEnabled = !matEnabled;
        syncMatUI();
        updateTotals();
      }
    });
  }

  // ── Mat card interaction (chiller / alone) ────────────────────────
  if (chillerMatCheck) {
    chillerMatCheck.addEventListener("click", (e) => {
      e.stopPropagation();
      chillerMatEnabled = !chillerMatEnabled;
      syncChillerMatUI();
      updateTotals();
    });
  }

  if (chillerMatCard) {
    chillerMatCard.addEventListener("click", () => {
      chillerMatEnabled = !chillerMatEnabled;
      syncChillerMatUI();
      updateTotals();
    });

    chillerMatCard.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        chillerMatEnabled = !chillerMatEnabled;
        syncChillerMatUI();
        updateTotals();
      }
    });
  }

  // ── Filters card interaction (chiller / alone) ─────────────────────
  if (filtersCheck) {
    filtersCheck.addEventListener("click", (e) => {
      e.stopPropagation();
      filtersEnabled = !filtersEnabled;
      syncFiltersUI();
      updateTotals();
    });
  }

  if (filtersCard) {
    filtersCard.addEventListener("click", () => {
      filtersEnabled = !filtersEnabled;
      syncFiltersUI();
      updateTotals();
    });

    filtersCard.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        filtersEnabled = !filtersEnabled;
        syncFiltersUI();
        updateTotals();
      }
    });
  }

  // ── Add to cart ───────────────────────────────────────────────
  if (addBtn) {
    addBtn.addEventListener("click", async () => {
      addBtn.disabled = true;

      let items = [];

      if (chillerEnabled) {
        if (chillerPkg === "bundle" && chillerBundleVariantId) {
          items = [{ id: chillerBundleVariantId, quantity: 1 }];
        } else {
          items = [{ id: chillpodVariantId, quantity: 1 }];
          if (chillerVariantId) items.push({ id: chillerVariantId, quantity: 1 });
          if (chillerMatEnabled && matVariantId)  items.push({ id: matVariantId, quantity: 1 });
          if (filtersEnabled && filtersVariantId) items.push({ id: filtersVariantId, quantity: 1 });
        }
      } else {
        if (noChillerPkg === "pro" && proVariantId) {
          items = [{ id: proVariantId, quantity: 1 }];
        } else {
          items = [{ id: chillpodVariantId, quantity: 1 }];
          if (iceEnabled) items.push({ id: Number(selectedIceId), quantity: 1 });
          if (matEnabled && matVariantId) items.push({ id: matVariantId, quantity: 1 });
        }
      }

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) throw new Error("cart/add failed");
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.dispatchEvent(new CustomEvent("cart:updated"));
        document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
        document.dispatchEvent(new CustomEvent("product:added"));
      } catch (e) {
        console.error(e);
      } finally {
        addBtn.disabled = false;
      }
    });
  }

  // ── Carousel (shared by all modal content sources) ──────────────
  const track    = document.getElementById("hlIceCarouselTrack");
  const prevBtn  = document.getElementById("hlIceCarouselPrev");
  const nextBtn  = document.getElementById("hlIceCarouselNext");
  const dotsWrap = document.getElementById("hlIceCarouselDots");

  let carouselTotal = 0;
  let carouselCur   = 0;

  function renderCarouselDots() {
    if (!dotsWrap) return;
    dotsWrap.innerHTML = "";
    for (let i = 0; i < carouselTotal; i++) {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "hl-ice-carousel-dot" + (i === 0 ? " is-active" : "");
      dot.dataset.index = String(i);
      dot.setAttribute("aria-label", `תמונה ${i + 1}`);
      dotsWrap.appendChild(dot);
    }
  }

  function goToSlide(index) {
    if (!track || carouselTotal === 0) return;
    carouselCur = Math.max(0, Math.min(index, carouselTotal - 1));
    track.style.transform = `translateX(${-carouselCur * 100}%)`;
    if (dotsWrap) {
      dotsWrap.querySelectorAll(".hl-ice-carousel-dot").forEach((d, i) => d.classList.toggle("is-active", i === carouselCur));
    }
    if (prevBtn) prevBtn.classList.toggle("is-hidden", carouselCur === 0);
    if (nextBtn) nextBtn.classList.toggle("is-hidden", carouselCur === carouselTotal - 1);
  }

  function setCarouselSlides(slideEls) {
    if (!track) return;
    track.style.transition = "none";
    track.innerHTML = "";
    slideEls.forEach((s) => track.appendChild(s));
    carouselTotal = slideEls.length;
    carouselCur = 0;
    track.style.transform = "translateX(0%)";
    requestAnimationFrame(() => { track.style.transition = ""; });

    renderCarouselDots();
    const showArrows = carouselTotal > 1;
    if (prevBtn) { prevBtn.style.display = showArrows ? "" : "none"; prevBtn.classList.toggle("is-hidden", true); }
    if (nextBtn) { nextBtn.style.display = showArrows ? "" : "none"; nextBtn.classList.toggle("is-hidden", carouselTotal <= 1); }
    if (dotsWrap) dotsWrap.style.display = showArrows ? "" : "none";
  }

  if (prevBtn) prevBtn.addEventListener("click", () => goToSlide(carouselCur - 1));
  if (nextBtn) nextBtn.addEventListener("click", () => goToSlide(carouselCur + 1));
  if (dotsWrap) {
    dotsWrap.addEventListener("click", (e) => {
      const dot = e.target.closest(".hl-ice-carousel-dot");
      if (!dot) return;
      goToSlide(Number(dot.dataset.index));
    });
  }

  if (track) {
    let touchStartX = 0, touchDeltaX = 0;
    track.addEventListener("touchstart", (e) => { touchStartX = e.touches[0].clientX; touchDeltaX = 0; track.style.transition = "none"; }, { passive: true });
    track.addEventListener("touchmove",  (e) => { touchDeltaX = e.touches[0].clientX - touchStartX; const offset = -(carouselCur * 100) + (touchDeltaX / track.parentElement.offsetWidth) * 100; track.style.transform = `translateX(${offset}%)`; }, { passive: true });
    track.addEventListener("touchend",   () => { track.style.transition = ""; if (touchDeltaX < -40) goToSlide(carouselCur + 1); else if (touchDeltaX > 40) goToSlide(carouselCur - 1); else goToSlide(carouselCur); });
  }

  // ── Shared details modal (ice blocks / chiller bundle / chiller alone) ──
  const modalOverlay = document.getElementById("hlIceModalOverlay");
  const modalClose   = document.getElementById("hlIceModalClose");
  const modalTitleEl = document.getElementById("hlModalTitle");
  const modalTextEl  = document.getElementById("hlModalText");

  // Accordion sections inside modal content (e.g. "מה כלול עם הצ'ילפוד?").
  // Delegated on modalTextEl itself since its innerHTML is replaced on every
  // open — a listener bound to a child would go stale.
  function animateScrollBy(container, delta, duration) {
    if (!container || delta <= 0) return;

    let frameId  = null;
    const startTop  = container.scrollTop;
    const startTime = performance.now();

    function stop() {
      if (frameId) cancelAnimationFrame(frameId);
      frameId = null;
      container.removeEventListener("wheel", stop);
      container.removeEventListener("touchstart", stop);
    }

    function step(now) {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased    = 1 - Math.pow(1 - progress, 3); // ease-out, matches CSS "ease" roughly
      container.scrollTop = startTop + delta * eased;  // re-clamped by the browser every frame
      if (progress < 1) {
        frameId = requestAnimationFrame(step);
      } else {
        stop();
      }
    }

    // Hand control back to the user immediately if they try to scroll themselves
    container.addEventListener("wheel", stop, { passive: true });
    container.addEventListener("touchstart", stop, { passive: true });
    frameId = requestAnimationFrame(step);
  }

  if (modalTextEl) {
    modalTextEl.addEventListener("click", (e) => {
      const header = e.target.closest(".hl-modal-accordion-header");
      if (!header) return;
      const body = header.nextElementSibling;
      if (!body || !body.classList.contains("hl-modal-accordion-body")) return;

      const isOpen = header.getAttribute("aria-expanded") === "true";
      const growBy = body.scrollHeight; // capture before the height changes

      header.setAttribute("aria-expanded", isOpen ? "false" : "true");
      body.style.maxHeight = isOpen ? "0px" : growBy + "px";

      if (!isOpen) {
        const scrollContainer = header.closest(".hl-ice-modal-body");
        animateScrollBy(scrollContainer, growBy, 300); // 300ms matches the CSS max-height transition
      }
    });
  }

  const MODAL_TEMPLATES = {
    "ice":            "hlModalTemplateIce",
    "chiller-bundle": "hlModalTemplateChillerBundle",
    "chiller-alone":  "hlModalTemplateChillerAlone",
  };

  let modalOpenerEl = null;

  function openContentModal(key, openerEl) {
    const tplId = MODAL_TEMPLATES[key];
    const tpl = tplId ? document.getElementById(tplId) : null;
    if (!tpl || !modalOverlay || !modalClose) return;

    const frag      = tpl.content.cloneNode(true);
    const titleSrc  = frag.querySelector(".hl-modal-source-title");
    const textSrc   = frag.querySelector(".hl-modal-source-text");
    const slidesSrc = frag.querySelector(".hl-modal-source-slides");

    if (modalTitleEl) modalTitleEl.textContent = titleSrc ? titleSrc.textContent.trim() : "";
    if (modalTextEl)  modalTextEl.innerHTML    = textSrc  ? textSrc.innerHTML : "";
    setCarouselSlides(slidesSrc ? Array.from(slidesSrc.children) : []);

    modalOpenerEl = openerEl || null;

    const scrollY = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top      = `-${scrollY}px`;
    document.body.style.width    = "100%";
    modalOverlay.classList.add("is-open");
    modalOverlay.setAttribute("aria-hidden", "false");
    modalClose.focus();
  }

  function closeContentModal() {
    if (!modalOverlay) return;
    const scrollY = Math.abs(parseInt(document.body.style.top || "0"));
    document.body.style.position = "";
    document.body.style.top      = "";
    document.body.style.width    = "";
    window.scrollTo(0, scrollY);
    modalOverlay.classList.remove("is-open");
    modalOverlay.setAttribute("aria-hidden", "true");
    if (modalOpenerEl) modalOpenerEl.focus();
  }

  if (modalClose)   modalClose.addEventListener("click", closeContentModal);
  if (modalOverlay) modalOverlay.addEventListener("click", (e) => { if (e.target === modalOverlay) closeContentModal(); });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modalOverlay && modalOverlay.classList.contains("is-open")) closeContentModal();
  });

  document.querySelectorAll("[data-modal]").forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.stopPropagation();
      openContentModal(trigger.dataset.modal, trigger);
    });
    trigger.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        e.stopPropagation();
        openContentModal(trigger.dataset.modal, trigger);
      }
    });
  });

  // ── Initial render ────────────────────────────────────────────
  syncChillerToggleUI();
  updateIceCard();
  updateTotals();
  syncIceUI();
  syncMatUI();
  syncChillerMatUI();
  syncFiltersUI();
};

// Auto-run
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", function () { window.hlInitIceAddon(); });
} else {
  window.hlInitIceAddon();
}